import type { ToolAnalyticsContext } from '@saas-pages/shared/public/runtime'
import type { Locale } from '@/shared/i18n'

export function recorderAnalytics(
  route: '/diktofon-online' | '/krugloe-video',
  utility: 'voice-recorder' | 'circle-video-recorder',
  locale: Locale,
): ToolAnalyticsContext {
  return {
    app: 'mediatik', domain: 'mediatik.ru', route, utility,
    processingMode: 'local', inputMethod: utility === 'voice-recorder' ? 'microphone' : 'camera', locale, landingLocale: locale,
  }
}
